import { EntityWithId, simpleClient } from 'services/apiGatewayClient';

const createClient = <T>() => simpleClient<T>();

/**
 * @deprecated Use RestApi instead. For more info, see here: https://bit.ly/3u0WlF7
 */
export const fetchFromServer = async <T>(url: string) => {
  const client = createClient<T>();

  return await client.getCollection(url).then((items: EntityWithId<T>[]) => {
    if (Array.isArray(items)) {
      return items.map(item => item.entity);
    }
  });
};

/**
 * @deprecated Use RestApi instead. For more info, see here: https://bit.ly/3u0WlF7
 */
export const fetchObjectFromServer = async <T>(url: string) => {
  const client = createClient<T>();
  return await client.get(url).then(items => {
    return items;
  });
};

/**
 * @deprecated Use RestApi instead. For more info, see here: https://bit.ly/3u0WlF7
 */
export const fetchJsonFromServer = async <T>(url: string) => {
  const client = createClient<T>();
  return await client.getJson(url);
};
